var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAll = function SvgAll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9E9E9E",
    d: "M4.125 3C3.504 3 3 3.504 3 4.125v5.932c0 .621.504 1.125 1.125 1.125h5.932c.621 0 1.125-.504 1.125-1.125V4.125c0-.621-.504-1.125-1.125-1.125zM4.125 12.818c-.621 0-1.125.504-1.125 1.125v5.932C3 20.496 3.504 21 4.125 21h5.932c.621 0 1.125-.504 1.125-1.125v-5.932c0-.621-.504-1.125-1.125-1.125zM12.818 4.125c0-.621.504-1.125 1.125-1.125h5.932C20.496 3 21 3.504 21 4.125v5.932c0 .621-.504 1.125-1.125 1.125h-5.932a1.125 1.125 0 0 1-1.125-1.125zM13.943 12.818c-.621 0-1.125.504-1.125 1.125v5.932c0 .621.504 1.125 1.125 1.125h5.932c.621 0 1.125-.504 1.125-1.125v-5.932c0-.621-.504-1.125-1.125-1.125z"
  })));
};
export default SvgAll;